<template>
    <div class="hot_path">
        <ul class="hot_path_nav_ul">
            <li class="hot_path_nav_li">
                <a class="hot_path_nav_a">
                    精品课程
                </a>
            </li>
        </ul>
        <ul class="hot_path_ul">
            <li v-for="(course, index) in classical_courses"
                :key="index"
                class="hot_path_li"
            >
                <div class="qa_item_div">
                    <div class="qa_item_question_div">
                        <router-link tag="a" :to="{ name: 'course', params: { id: course.id } }">
                            <img :src="course.picture_url"
                                 class="item_question_avatar"/>
                        </router-link>
                        <div class="item_question">
                            <a v-if="course.name.length<=10" :href="'/courses/'+course.id"
                               class="item_question_title">
                                {{course.name}}
                            </a>
                            <a v-else :href="'/courses/'+course.id"
                               class="item_question_title">
                                {{course.name.substring(0,10)}}...
                            </a>
                            <div class="item_question_base_info">
                                <span>主讲：</span>
                                <span>{{course.teacher.name}}</span>
                                <!--  -->
                                <!--<i class="fa fa-eye"></i>-->
                                <!--<span class="margin-right-5">{{question.views}}</span>-->
                                <!--<i class="fa fa-thumbs-up"></i>-->
                                <!--<span class="margin-right-5">{{question.likes_count}}</span>-->
                                <!--<i class="fa fa-comments"></i>-->
                                <!--<span class="margin-right-5">{{question.answers_count}}</span>-->
                                <!--<span class="margin-right-5">{{question.created_at.split('-')[0]}}年{{question.created_at.split('-')[1]}}月</span>-->
                                <!--<span class="margin-right-10">发布于</span>-->
                                <!--<span style="color: #66CCFF" class="margin-right-10">{{post.column.display_name}}</span>-->
                                <!--<span style="color: #00965e" class="margin-right-10" v-for="tag in post.tags" :key="tag['id']">{{tag.name}}</span>-->

                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script type="text/javascript">
    import {mapState} from 'vuex'

    export default {
        computed: {
            ...mapState({
                hot_path: state => state.questions.related_stuff_information.hot_path,
                classical_courses: state => state.questions.related_stuff_information.classical_courses,
            })
        }
    }

</script>
<style type="text/css" scoped>
    .margin-right-5 {
        margin-right: 5px;
    }

    .qa_item_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eee;
    }

    .qa_item_question_div {
        display: flex;
        /*width: 83%;*/
    }

    .item_question {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        /*max-width: 83%;*/
        /*max-width: 600px;*/
    }

    .item_question_avatar {
        width: 50px;
        height: 50px;
        /*border-radius: 50%;*/
        /*margin-top: 20px;*/
    }

    .item_question_title {
        display: inline-block;
        white-space: nowrap;
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #4c5157;
        max-width: 100%;
    }

    .item_question_base_info {
        margin-top: 8px;
        font-size: 13px;
        color: #9b9da2;
    }

    .hot_path {
        background: #fff;
        margin-left: 10px;
        margin-bottom: 10px;
        padding: 15px;
    }

    .hot_path_nav_ul {
        margin-bottom: 10px;
        border: none;
        border-bottom: 1px solid #eee;
        display: flex;
    }

    .hot_path_nav_li {

    }

    .hot_path_nav_a {
        display: block;
        padding: 0 0 4px;
        margin: 0 48px 0 0;
        font-size: 16px;
        color: #4c5157;
        background: transparent;
        border: none;
        border-bottom: 1px solid transparent;
    }

    .hot_path_li {
        font-size: 14px;
    }

    .hot_path_li:hover {
        background: #f5f5f5;
    }

    .hot_path_a {
        display: block;
        padding: 12px;
        width: 100%;
        height: 100%;
        color: #4c5157;
    }

    .hot_path_a:hover {
        color: #4c5157;
        background: #f5f5f5;
    }
</style>
